import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://ebikeservices.test/api/v1';
const baseURL = 'https://ebikerestservices.alvapy.com/api/v1';

//const baseURL = 'http://127.0.0.1:8000/api/v1';


axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);
